import { ChevronRight } from "lucide-react";

// crumbs: [{ id, name }, ...]
export default function Breadcrumb({ crumbs, onNavigate }) {
  if (crumbs.length <= 1) return null;
  return (
    <div className="flex items-center gap-1 text-sm text-gray-600 px-3 py-2 border-b">
      {crumbs.map((c, i) => (
        <span key={c.id} className="flex items-center gap-1">
          <button
            onClick={() => onNavigate(i)}
            className={`hover:underline ${i === crumbs.length - 1 ? "font-semibold text-gray-900" : ""}`}
          >
            {c.name}
          </button>
          {i < crumbs.length - 1 && <ChevronRight className="w-3 h-3" />}
        </span>
      ))}
    </div>
  );
}
